import { all } from 'redux-saga/effects';
import calculationSaga from './calculation-sagas';
import calculationItemSaga from './calculation-item-sagas';

export default function* rootSaga() {
  yield all([
    calculationSaga(),
    calculationItemSaga()
  ]);
}
